import { render, staticRenderFns } from "./ColorModuleRequest.vue?vue&type=template&id=7f0c60aa&scoped=true"
import script from "./ColorModuleRequest.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorModuleRequest.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorModuleRequest.vue?vue&type=style&index=0&id=7f0c60aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0c60aa",
  null
  
)

export default component.exports